import { Alert } from "@productlane/ui"

import { useTrial } from "@/lib/useTrial"
import { SettingsContainer } from "@/screens/settings/settings-switches/settings-container"
import { SettingsHeader } from "../../settings-header"
import { ImportPortalBadge } from "../import-portal"
import { ChangelogCsvUploadField } from "./steps/changelog-csv-upload-field"

export function ChangelogCsvImportPage() {
	const { hasTrialEnded } = useTrial()

	return (
		<>
			<SettingsHeader
				title="Changelog CSV import"
				subtitle={null}
				titleSuffix={<ImportPortalBadge />}
			/>
			{!hasTrialEnded ? (
				<SettingsContainer>
					<ChangelogCsvUploadField />
				</SettingsContainer>
			) : (
				<Alert variant="warning">Trial ended. Upgrade to import data.</Alert>
			)}
		</>
	)
}
